import React from "react";
import WebcamVideo from "../../components/WebcamVideo/WebcamVideo";

export default function ImageProcessing() {
  return <WebcamVideo />;
}
